module.exports = __webpack_public_path__ + "static/img/3.082c60f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/eng/3.png
// module id = Zv7y
// module chunks = 0